import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { Link as RouterLink } from "react-router-dom"

import Column from "../../../common/components/Column"
import { formatCurrencyLong } from "../../../common/utils"
import { PLAN_BILLING_SECTIONS, createPlanBillingURL } from "../settings"
import { MLS_ACTIVATION_TIMELINE } from "./mlsPurchaseActivationCopy"

export default function MlsPurchaseSuccessDialog({ open, purchase, onClose }) {
  if (!purchase) {
    return null
  }

  const names = (purchase.mls_names || []).filter(Boolean).join(", ")

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Column sx={{ alignItems: "center", textAlign: "center", gap: 1.5 }}>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 48 }} />
          <Typography variant="h6" fontWeight={700}>
            Payment successful
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {purchase.total_monthly != null ? (
              <>
                You&apos;ve paid{" "}
                <strong>
                  {formatCurrencyLong(purchase.total_monthly)}/month
                </strong>
                {names ? (
                  <>
                    {" "}
                    for <strong>{names}</strong>
                  </>
                ) : null}
                .
              </>
            ) : names ? (
              <>
                Your request for <strong>{names}</strong> has been received.
              </>
            ) : (
              "Your MLS purchase has been received."
            )}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {MLS_ACTIVATION_TIMELINE}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Go to{" "}
            <Button
              component={RouterLink}
              to={createPlanBillingURL(PLAN_BILLING_SECTIONS.mlsPurchases)}
              onClick={onClose}
              size="small"
              sx={{ p: 0, minWidth: 0, verticalAlign: "baseline" }}
            >
              Settings → MLS purchase history
            </Button>{" "}
            for more details.
          </Typography>
        </Column>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button variant="contained" onClick={onClose}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  )
}
